// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import 'promise-polyfill/src/polyfill';
import "polyfills";

require("@rails/ujs").start();
require("turbolinks").start();
require("@rails/activestorage").start();
// require("channels")

import "controllers";
import "cookie-consent.js.erb";

import { Foundation } from 'foundation-sites/js/foundation.core';
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery';
import { Toggler } from 'foundation-sites/js/foundation.toggler';
import { DropdownMenu } from 'foundation-sites/js/foundation.dropdownMenu';
import { ResponsiveToggle } from 'foundation-sites/js/foundation.responsiveToggle';
import { Reveal } from 'foundation-sites/js/foundation.reveal';
import { Tooltip } from 'foundation-sites/js/foundation.tooltip';
import { Tabs } from 'foundation-sites/js/foundation.tabs';
import { Triggers } from 'foundation-sites/js/foundation.util.triggers';
import { Touch } from 'foundation-sites/js/foundation.util.touch';

Foundation.addToJquery($);

Touch.init($);
Triggers.init($, Foundation);
MediaQuery._init();

Foundation.plugin(DropdownMenu, 'DropdownMenu');
Foundation.plugin(Reveal, 'Reveal');
Foundation.plugin(Tabs, 'Tabs');
Foundation.plugin(Toggler, 'Toggler');
Foundation.plugin(Tooltip, 'Tooltip');
Foundation.plugin(ResponsiveToggle, 'ResponsiveToggle');

import { loadMaps } from 'maps.js.erb';
import { searchBar } from 'searchbar.js.erb';
import { initializeCategoriesMenu } from 'categories-menu.js';
import { initializeImagePicker } from 'image-picker.js';
import { turboScroll } from 'turbo-scroll.js';
import { clearFormInputs } from 'turbo-forms.js'

document.addEventListener("turbolinks:load", () => {
  $(document).foundation();
  turboScroll();
  loadMaps();
  searchBar();
  initializeCategoriesMenu();
  initializeImagePicker();

  if (window.dataLayer) {
    window.dataLayer.push({'event':'pageview', 'virtualPath': window.location.pathname});
  }
})

document.addEventListener("turbolinks:before-cache", function() {
  const tooltips = $('.has-tip');
  if (tooltips.length > 0) {
    tooltips.foundation('destroy');
    tooltips.attr('data-tooltip', 'yes');
  };
  clearFormInputs();

  const purechat = document.querySelector("#PureChatWidget");
  if (purechat) {
    purechat.parentElement.removeChild(purechat);
  }
});

const pages = require.context('pages/', true, /\.js$/);
pages.keys().forEach(pages)
